export class PGNotificationCenter {
    static instance: PGNotificationCenter;
    private listeners: Map<string, Function> = new Map();

    public static getInstance(): PGNotificationCenter {
        if (!PGNotificationCenter.instance) {
            PGNotificationCenter.instance = new PGNotificationCenter();
        }
        return PGNotificationCenter.instance;
    }

    public addListener(key: string, fn: Function) {
        this.listeners.set(key, fn);
    }

    public messageEmitter(name: string, classId: number, message: Object) {
        const observerKey = `${name}`;
        this.listeners.forEach((fn, key) => {
            if (key === observerKey) {
                fn(message);
            }
        });
    }
}
